/* eslint-disable */
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Button } from './Button'
import Icon from './Icon'
import IP_LIMIT from '../../static/images/ip_limit.png'
// import httpRequest from '../../utils/httpRequest'
import zIndex from '../../utils/zIndexScale'
import { setShowIpValidation } from '../../redux/global/action'

const Layer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${zIndex.modal};
  background: rgba(0, 0, 0, 0.5);
  display: ${props => (props.visible ? 'block' : 'none')};
`

const Wrapper = styled.div`
  width: 500px;
  padding: 20px;
  padding-top: 0;
  background: rgb(216, 216, 216);
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  @media (max-width: 768px) {
    width: 100%;
    min-width: 300px;
    max-width: 300px;
    padding: 15px;
    top: 50%;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #12161c;
  position: relative;
  img {
    width: 150px;
    margin-bottom: 30px;
  }
  a {
    color: inherit;
  }
  p {
    margin-top: 30px;
    align-self: flex-start;
    a {
      color: #f0b90b;
      text-decoration: underline;
    }
  }
  p.bold {
    font-weight: bold;
  }
`

const Close = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  color: #848e9c;
  &:hover {
    color: #f0b90b;
  }
`

const IPButton = styled(Button)`
  width: 170px;
  margin-right: 15px;
  margin-top: 10px;
`

const OtherButton = styled(IPButton)`
  background: grey;
`

const ButtonWrap = styled.div`
  display: flex;
  margin-top: 30px;
  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }
`

class IpValidation extends PureComponent {
  static propTypes = {
    cancel: PropTypes.func,
    dispatch: PropTypes.func.isRequired,
    isIpValid: PropTypes.bool,
    isShowIpValidation: PropTypes.bool,
    i18nData: PropTypes.object,
    showClose: PropTypes.bool,
  }

  static defaultProps = {
    cancel: () => {},
    isIpValid: true,
    isShowIpValidation: true,
    i18nData: {},
    showClose: true,
  }

  _handleClick = () => {
    this._close()
  }

  _close = () => {
    const { dispatch } = this.props
    dispatch(setShowIpValidation(false))
  }

  render() {
    const { isIpValid, isShowIpValidation, i18nData, showClose } = this.props
    return (
      <Layer visible={!isIpValid && isShowIpValidation}>
        <Wrapper>
          <Content>
            {/* <img src={IP_LIMIT} alt={true} /> */}
            <p>
              It seems you are accessing{' '}
              <a href="https://www.binance.org" target="_blank">
                www.binance.org
              </a>{' '}
              from an IP address belonging to one of the following countries:
            </p>
            <p>
              {i18nData && i18nData['blocked.country.list']
                ? i18nData['blocked.country.list']
                : `United States of America, Albania, Bosnia and Herzegovina, Belarus, Congo (DRC), Côte
              d'Ivoire, Crimea, Cuba, Iraq, Iran, North Korea, Liberia, Macedonia, Myanmar, Serbia,
              Sudan, Syria, Zimbabwe.`}
            </p>
            {/* <p>
              Please note that by 19 October 2019 (UTC 00:00),trading and accessing to the wallet
              interface through{' '}
              <a href="https://www.binance.org" target="_blank">
                www.binance.org
              </a>{' '}
              will no longer be available to users with IP address from the countries listed above.
              Please download Trubi Wallet or other alternatives.
            </p> */}
            {/* <p className="bold">
              For alternatives and solutions, please see this
              <a href="https://docs.binance.org/wallets.html" target="_blank">
                {' '}
                document
              </a>
            </p> */}
            <ButtonWrap>
              <IPButton>
                <span>
                  <a href="https://www.trubi.io">Trubi Wallet</a>
                </span>
              </IPButton>
              <OtherButton>
                <span>
                  <a href="https://docs.binance.org/wallets.html">Other Alternatives</a>
                </span>
              </OtherButton>
            </ButtonWrap>
          </Content>
          {showClose && (
            <Close onClick={this._close}>
              <Icon type="close" size="16" />
            </Close>
          )}
        </Wrapper>
      </Layer>
    )
  }
}

const mapStateToProps = ({ globalData: { isIpValid, isShowIpValidation }, i18n: { data } }) => ({
  isIpValid,
  isShowIpValidation,
  i18nData: data,
})

export default connect(mapStateToProps)(IpValidation)
